import { CONSTANT, CommonAction, UserSwitchServices, WebsiteCookies, REDIRECT, signIn, afterSigninPath } from '@/imports-files/components/switch-user'

export class UserSwitchActions {
    constructor(router, session, setApiError) {
        this.router = router;
        this.commonAction = new CommonAction();
        this.userSwitchServices = new UserSwitchServices();
        this.session = session;
        this.websiteCookies = new WebsiteCookies();
        this.setApiError = setApiError
        this.NAVBAR_LOCALSTORAGE_KEY = 'navbarStatus'
        this.activities_values = {   "selectedSubSidebarOptions":"activities",
            "selectedParentSubSidebarOptions" :"activities",
            "key" : "activities"
        };
    }

    async switchUser(entity_id) {
        let userType = ''
        if (this.router.asPath.includes('clients')) {
            userType = CONSTANT.user_types.agency_user;
        }
        else {
            userType = CONSTANT.user_types.client_user;
        }

        let redirect_url = '';
        let body = '';
        let result = '';
        

        switch (userType) {
            case CONSTANT.user_types.client_user:            
                body = { user_type: 'ClientUser' }
                result = await this.userSwitchServices.switchRole(body);
                await signIn('credentials', {redirect: false, body: JSON.stringify(result.data)});
                afterSigninPath(this.router, result.data)
                localStorage.setItem(this.NAVBAR_LOCALSTORAGE_KEY, JSON.stringify(this.activities_values));
                break;
            case CONSTANT.user_types.agency_user:
                body = { user_type: 'AgencyUser', entity_id: entity_id }
                result = await this.userSwitchServices.switchRole(body);
                await signIn('credentials', {redirect: false, body: JSON.stringify(result.data)});
                afterSigninPath(this.router, result.data)
                localStorage.setItem(this.NAVBAR_LOCALSTORAGE_KEY, JSON.stringify(this.activities_values));
                break;
            default: return 'user is not present'
        }
    }

    async getSwitchData() {
        let result = await this.userSwitchServices.getSwitchData({});
        this.setApiError(result.request)
        return result.data
    }
}